import { CheckSvg } from "@components/index";

export const RegularBusinessCard = ({
  uniqueId,
  name,
  onSetDefault,
}: {
  uniqueId: string;
  name: string;
  onSetDefault: (uniqueId: string) => void;
  onIgnoreMileage: (uniqueId: string) => void;
}) => (
  <div className="w-full max-w-[414px] rounded-lg border border-black-8">
    <div
      className="cursor-pointer rounded-lg bg-black-4"
      onClick={() => onSetDefault(uniqueId)}
    >
      <div className="flex h-14 items-center gap-x-2 border-b border-b-black-8 bg-white-8 px-6 text-button text-primary-300">
        <CheckSvg />
        Mark as Default
      </div>
      <div className="flex h-[132px] flex-col justify-end rounded-b-lg p-6">
        <div className="font-light text-black-54">Business name</div>
        <div className="text-300 font-bold text-black-100">{name}</div>
      </div>
    </div>
    <div
      className="flex h-[52px] cursor-pointer items-center justify-between px-6 text-button text-black-54"
      onClick={() => onSetDefault(uniqueId)}
    ></div>
  </div>
);
